import AppButton from "../../views/components/Common/AppButton"
import {Formik} from "formik"
import {Form} from "react-bootstrap"
import React, {useState} from "react"
import * as yup from "yup"
import useJwt from "../../services/useJwt"
import Message from "../../utility/notifications/Message"
import AppTextInput from "../../views/components/forms/AppTextInput"

type UpdatePasswordProps = {
    username: string
    password: string
    rememberClient?: boolean
    onSuccess: (data: any) => void
    onBack: () => void
    twoFaCode?: string
}

export default function UpdatePassword({
    username,
    password,
    rememberClient = false,
    onSuccess,
    onBack,
    twoFaCode,
}: UpdatePasswordProps) {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const schema = yup.object().shape({
        newPassword: yup.string().required().label("Password"),
    })

    const handleSubmit = async (values: any) => {
        setIsSubmitting(true)

        try {
            const response = await useJwt.login({
                userNameOrEmailAddress: username,
                password,
                newPassword: values.newPassword,
                twoFactorVerificationCode: twoFaCode,
                twoFactorRememberClient: rememberClient,
            })

            if (response.status === 200) {
                onSuccess(response.data)
            }
        } catch (err: any) {
            Message(
                err.response?.data?.error?.message || "Invalid verification code",
                err.response?.data?.error?.details || "",
                "error"
            )
        } finally {
            setIsSubmitting(false)
        }
    }

    return <>
        <div className="my-4">
            <div className="text-center mb-4">
                <AppButton
                    type="button"
                    title="Back to login"
                    buttonSize="sm"
                    variant="back"
                    onClick={onBack}
                />
            </div>

            <h1 className="h3 mb-3 fw-bold text-primary text-center">
                Password expired
            </h1>
            <p className="text-center text-muted mb-4">Your password has expired. Please enter a new password here</p>
        </div>

        <Formik
            enableReinitialize
            initialValues={{
                newPassword: undefined,
            }}
            validationSchema={schema}
            onSubmit={handleSubmit}
        >
            {({ handleSubmit }) => (
                <Form className="auth-login-form mt-2" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <AppTextInput
                            required
                            type={"password"}
                            name={"newPassword"}
                            label={'Enter a new password here'}
                        />
                    </div>

                    <AppButton
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        type="submit"
                        title="Verify and Login"
                        buttonSize="lg"
                        className="w-100"
                    />
                </Form>
            )}
        </Formik>
    </>
}